import { TextLanguage, TranslatedText } from "Store/texts/interfaces";

import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { BaseProduct } from "Store/interfaces/products/checkPrice/BaseProduct";
import { TractorType } from "Store/interfaces/products/checkPrice/riskProducts/VehicleProducts/Tractor";
import { TractorCoverage } from "Store/interfaces/products/coverage";
import { TfaAmount } from "../vehicleInterfaces";

export interface TractorPriceRequestInfo extends BaseProduct {
  tractorType: TractorType;
  model: string;
  modelYear: number;

  coverageAmount: number;

  injuries: number;
  injuryYear?: number;

  dateOfBirth?: string;
}

export enum TractorInsuranceType {
  TRACTOR_LIABILITY = "traktorAnsvar",
  TRACTOR_FIRE_AND_THEFT = "traktorDelkasko",
  TRACTOR_FULL_OWN_DAMAGE = "traktorKasko",
}

type TractorTile = {
  productIntro: {
    ingress: TranslatedText;
  };
  productDetails: {
    heading: TranslatedText;
    ingress: TranslatedText;
  };
  productPrice: {
    heading: TranslatedText;
    ingress: TranslatedText;
    deductibleInfo: {
      title: TranslatedText;
      description: TranslatedText;
    };
  };
};

type TractorFormTexts = {
  [key: string]: {
    label: TranslatedText;
    hint?: TranslatedText;
    placeholder?: TranslatedText;
    error: Record<string, TranslatedText>;
    options: Record<string, TranslatedText>;
  };
};

export interface TractorTexts {
  details: {
    [key: string]: Record<TextLanguage, string>;
  };
  formText: { checkPrice: TractorFormTexts };
  tile: TractorTile;
  title: TranslatedText;
  name: TranslatedText;
  types: {
    coverageGroup: Record<TractorCoverage, TranslatedText>;
  };
}

export interface TractorProductIntroFormValues {
  tractorType: TractorType;
  firstRegistered: number;
  brandOrModel: string;
}

export interface TractorProductDetailsFormValues extends InjuriesFormValues {
  coverageAmount: number;
}

export interface TractorProductPriceFormValues extends TfaAmount {
  coverageAmount: TractorProductDetailsFormValues["coverageAmount"];
  coverage: TractorCoverage;
}
